import type { IconNode } from '../types';

/**
 * @name face-slightly-smiling-plus
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTMuMjY3IDIuMDhhMTAgMTAgMCAxMDguNjUzIDguNjUzIiAvPgogIDxwYXRoIGQ9Ik0xNSAxMFY5IiAvPgogIDxwYXRoIGQ9Ik0xNiA1aDYiIC8+CiAgPHBhdGggZD0iTTE2LjQ3MiAxNWE2IDYgMCAwMS04Ljk0MyAwIiAvPgogIDxwYXRoIGQ9Ik0xOSAydjYiIC8+CiAgPHBhdGggZD0iTTkgMTBWOSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/face-slightly-smiling-plus
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const FaceSlightlySmilingPlus: IconNode = [
  ['path', { d: 'M13.267 2.08a10 10 0 108.653 8.653' }],
  ['path', { d: 'M15 10V9' }],
  ['path', { d: 'M16 5h6' }],
  ['path', { d: 'M16.472 15a6 6 0 01-8.943 0' }],
  ['path', { d: 'M19 2v6' }],
  ['path', { d: 'M9 10V9' }],
];

export default FaceSlightlySmilingPlus;
